import {
  Alert,
  Avatar,
  Backdrop,
  Badge,
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  Grid,
  Menu,
  MenuItem,
  Select,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography
} from '@mui/material'
import { Add, AutoDeleteOutlined, LocalAtmOutlined, ReceiptOutlined } from '@mui/icons-material'
import Masks from '../../../components/Shared/Masks'
import React, { useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import moment from 'moment'
import { api } from '../../../services/Main/Api'
import successAnimation from '../../../assets/animations/success.json'
import AnimationGlobal from '../../../components/Shared/animations/AnimationGlobal'
import CircularProgress from '@mui/material/CircularProgress'
import NoResultsAnimation from '../../../components/Shared/animations/NoResultsAnimation'
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined'
import AllInclusiveOutlinedIcon from '@mui/icons-material/AllInclusiveOutlined'
import CreditScoreOutlinedIcon from '@mui/icons-material/CreditScoreOutlined'
import RentContractFeeDetail from './RentContractFeeDetail'
import Context from '../../../contexts/Context'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import ReceiptLong from '@mui/icons-material/ReceiptLong'
import RentContractFeeForm from "./RentContractFeeForm";
import RentDailyFeeForm from "./RentDailyFeeForm";

function RentContractFee(props) {
  //////////////////////////////////////
  //// States, Provider and Hooks /////
  /////////////////////////////////////
  const { id } = useParams();
  const { dataProvider, screenRefresh, setScreenRefresh, refreshScreen, setRefreshScreen } = useContext(Context)

  const [data, setData] = useState({});
  const [openDelete, setOpenDelete] = useState(false);
  const [handleItem, setHandleItem] = useState({});
  const [isLoading, setisLoading] = useState(false);

  const [openDetailDialog, setOpenDetailDialog] = useState(false);
  const [idDetailDialog, setIdDetailDialog] = useState(null);

  const [activeBackdrop, setActiveBackdrop] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  // Filtro (tipo e período)
  const [toogleTypeBilling, setToogleTypeBilling] = useState(""); // "default" | "today" | "7days" | etc.
  const [monthTypeChoices, setMonthTypeChoices] = useState([]);
  const [monthTypeBilling, setMonthTypeBilling] = useState(moment().format("MM/YYYY")); // exibição/param

  const [idRent, setIdRent] = useState(() => id || dataProvider?.rentId || null);

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [openForm, setOpenForm] = useState(false);

  useEffect(() => {
    setIdRent(id || dataProvider?.rentId || null)
  }, [id, dataProvider?.rentId])

  function getRentContractFee() {
    if (!idRent) return; // garante ID válido antes de buscar
    setisLoading(true);
    const params = {
      rent_contract: idRent,
      type_billing: toogleTypeBilling,     // valores esperados pelo backend: "default", "today", "7days", ...
      month_type_billing: monthTypeBilling // "MM/YYYY" ou rótulos como "Hoje" apenas para DIÁRIO
    }
    api.get(`/rent-contract/fee/`, { params })
        .then(response => {
          const { data } = response
          setData(data)
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => setisLoading(false))
  }

  const handleChoices = () => {
    if (!idRent) return;
    const params = { rent_contract: idRent }
    api.get("/rent-contract/choices/", { params })
        .then(response => {
          setMonthTypeChoices(response.data.month_choices || [])
        })
        .catch(error => {
          console.log(error)
        })
  };

  // Carrega choices quando tiver idRent
  useEffect(() => {
    if (!idRent) return;
    handleChoices();
  }, [idRent])

  // Define filtro inicial baseado na frequência de cobrança
  useEffect(() => {
    if (!idRent) return;
    if (props.reqData?.billing_frequency === "MONTHLY") {
      setToogleTypeBilling("default");                 // tipo para backend
      setMonthTypeBilling(moment().format("MM/YYYY")); // param para backend (exibe formatado no botão)
    } else if (props.reqData?.billing_frequency === "DAILY") {
      setToogleTypeBilling("today"); // tipo para backend
      setMonthTypeBilling("Hoje");   // rótulo no botão
    }
  }, [props.reqData?.billing_frequency, idRent]);

  // Busca ao mudar filtros ou idRent
  useEffect(() => {
    if (!idRent) return;
    if (!toogleTypeBilling) return;
    getRentContractFee()
  }, [idRent, toogleTypeBilling, monthTypeBilling])

  // Refresh externo
  useEffect(() => {
    if (!idRent) return;
    if (screenRefresh) {
      getRentContractFee();
    }
  }, [refreshScreen, screenRefresh, idRent]);

  useEffect(() => {
    if (!idRent) return;
    if (screenRefresh) {
      handleChoices();
    }
  }, [refreshScreen, screenRefresh, idRent]);

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = (value, type = 'default') => {
    if (typeof value === 'string' || value instanceof String) {
      if (value) {
        setMonthTypeBilling(value) // rótulo/param
      }
      setToogleTypeBilling(type)   // tipo para backend
    }
    setAnchorEl(null);
  };

  function handleTypeBilling(e, newOption) {
    setToogleTypeBilling(newOption)
  }

  function handleDelete(itemId) {
    api.delete(`rent_contract/fee/${itemId.id}/`)
        .then(() => {
          getRentContractFee()
          setOpenDelete(false)
        })
        .catch(error => {
          console.log(error)
        })
  }

  const handleAfterSave = () => {
    setActiveBackdrop(true)
    setIsSuccess(true)
    getRentContractFee()
    setScreenRefresh(true)
    setTimeout(() => {
      setActiveBackdrop(false)
      setIsSuccess(false)
    }, 2500)
  }

  return (
      <Grid item xs={12}>
        {idDetailDialog &&
            <RentContractFeeDetail
                openDialog={openDetailDialog}
                handleDialogClose={() => {
                  setOpenDetailDialog(false)
                  getRentContractFee()
                }}
                idFee={idDetailDialog}
                reqData={props.reqData}
                loadRentContractFee={getRentContractFee}
            />
        }

        {!isLoading ?
            <Card>
              <CardContent>
                <Grid container spacing={2} >
                  <Grid item md={6} sm={12}>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Avatar sx={{ bgcolor: 'primary.main' }}><ReceiptLong /></Avatar>
                      <Typography variant={"h5"} sx={{ ml: 1 }}>Cobranças</Typography>
                    </Box>
                  </Grid>

                  <Grid item md={4} sm={12} sx={{ textAlign: "right", display: 'flex' }} alignItems={'center'} justifyContent={'end'}>
                    <Button
                        id="basic-button"
                        aria-controls={open ? 'basic-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                        onClick={handleMenuClick}
                        variant={'outlined'}
                        size={'small'}
                        endIcon={<KeyboardArrowDownIcon />}
                    >
                      {toogleTypeBilling === 'default'
                          ? moment(monthTypeBilling, 'MM/YYYY').format('MMMM/YYYY')
                          : monthTypeBilling}
                    </Button>

                    <Menu
                        id="basic-menu"
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleMenuClose}
                        MenuListProps={{ 'aria-labelledby': 'basic-button' }}
                    >
                      {props.reqData?.billing_frequency === "MONTHLY" && (
                          <>
                            {monthTypeChoices.map((item, index) => (
                                <MenuItem key={index} onClick={() => { handleMenuClose(item) }}>
                                  {moment(item, "MM/YYYY").format("MMMM/YYYY")}
                                </MenuItem>
                            ))}
                            <Divider />
                            <MenuItem onClick={() => { handleMenuClose('Cobrança Única', 'month') }}>
                              Cobrança Única
                            </MenuItem>
                            <MenuItem onClick={() => { handleMenuClose('Cobrança Recorrente', 'recurring') }}>
                              Cobrança Recorrente
                            </MenuItem>
                            <MenuItem onClick={() => { handleMenuClose('Cobrança Parcelada', 'installment') }}>
                              Cobrança Parcelada
                            </MenuItem>
                          </>
                      )}

                      {props.reqData?.billing_frequency === "DAILY" && (
                          <>
                            <MenuItem onClick={() => { handleMenuClose('Hoje', 'today') }}>
                              Hoje
                            </MenuItem>
                            <MenuItem onClick={() => { handleMenuClose('Próximos 7 Dias', '7days') }}>
                              Próximos 7 Dias
                            </MenuItem>
                          </>
                      )}
                    </Menu>
                  </Grid>

                  <Grid item md={2} sm={12} sx={{ alignItems: "center", display: "flex" }}>
                    <Button
                        variant="contained"
                        startIcon={<Add />}
                        size={"small"}
                        onClick={() => setOpenForm(true)}
                    >
                      Nova Cobrança
                    </Button>
                  </Grid>
                </Grid>
              </CardContent>

              <Divider />

              <TableContainer>
                {data?.results?.length > 0 ?
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>Código</TableCell>
                          <TableCell>
                            {props.reqData?.billing_frequency === "MONTHLY" ? "Mês/Ano" : "Data"}
                          </TableCell>
                          <TableCell>Categoria</TableCell>
                          <TableCell>Ações</TableCell>
                          <TableCell sx={{ textAlign: "right" }}>Valor</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {data.results.map(item =>
                            <TableRow
                                key={item.id}
                                hover
                                sx={item.status === "ACTIVE" ? { 'cursor': 'pointer' } : { 'cursor': 'pointer', opacity: 0.4 }}
                                onClick={(e) => {
                                  e.stopPropagation()
                                  let feeId = item.id
                                  if (item.parent) {
                                    feeId = item.parent
                                  }
                                  setIdDetailDialog(feeId)
                                  setOpenDetailDialog(true)
                                }}
                            >
                              <TableCell>
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                  COB-{item.id}
                                </Box>
                              </TableCell>

                              <TableCell>
                                {props.reqData?.billing_frequency === "MONTHLY" ? (
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                      {moment(`${item?.month}-${item?.year}`, 'MM-YYYY').format('MMM/YYYY')}
                                    </Box>
                                ) : (
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                      {moment(item.reference_date).format('DD/MM/YYYY')}
                                    </Box>
                                )}
                              </TableCell>

                              <TableCell>{item.category}</TableCell>

                              <TableCell>
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                  <Tooltip title={item.invoice_rule.value}>
                                    {item.invoice_rule?.id === "NO_ACTION" ?
                                        <ReceiptOutlined color="disabled" />
                                        : item.invoice_rule?.id === "INVOICE_SUM_VALUE" ?
                                            <ReceiptOutlined color="success" />
                                            : item.invoice_rule?.id === "INVOICE_DISCOUNT_VALUE" &&
                                            <ReceiptOutlined color="warning" />
                                    }
                                  </Tooltip>

                                  <Tooltip title={item.transfer_rule.value}>
                                    {item.transfer_rule?.id === "NO_ACTION" ?
                                        <LocalAtmOutlined color="disabled" />
                                        : item.transfer_rule?.id === "TRANSFER_SUM_VALUE" ?
                                            <LocalAtmOutlined color={"success"} />
                                            : item.transfer_rule?.id === "TRANSFER_DISCOUNT_VALUE" &&
                                            <LocalAtmOutlined color={"warning"} />
                                    }
                                  </Tooltip>

                                  {item.recurring === true ?
                                      <Tooltip title={"Cobrança Recorrente"}><AllInclusiveOutlinedIcon color={"action"} sx={{ marginLeft: "2px" }} /></Tooltip>
                                      : item.installment === true ?
                                          <Tooltip title={"Cobrança Parcelada"}><CreditScoreOutlinedIcon color={"action"} /></Tooltip>
                                          :
                                          <Tooltip title={"Cobrança Mensal"}><CalendarMonthOutlinedIcon color={"action"} /></Tooltip>}
                                  {item.payment === true &&
                                      <Tooltip title={"Cobrança foi adicionada para pagamento"}><CreditScoreOutlinedIcon color={"action"} sx={{ marginLeft: "2px" }} /></Tooltip>}
                                  {item.status !== "ACTIVE" &&
                                      <Tooltip title={"Cobrança foi desativada"}><AutoDeleteOutlined color={"error"} sx={{ marginLeft: "2px" }} /></Tooltip>}
                                </Box>
                              </TableCell>

                              <TableCell>
                                <Box
                                    sx={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      fontWeight: "bold",
                                      justifyContent: "end"
                                    }}
                                >
                                  {item.value_type === "PERCENTAGE_VALUE"
                                      ? `${item.value?.toString()}% do ${item.percentage_rule}`.toLowerCase()
                                      : `${Masks.money(item.value?.toString())}`
                                  }
                                </Box>
                              </TableCell>
                            </TableRow>
                        )}
                      </TableBody>
                    </Table>
                    :
                    <NoResultsAnimation />
                }
              </TableContainer>

              {props.reqData?.billing_frequency === "MONTHLY" ?
                  <RentContractFeeForm
                      open={openForm}
                      onClose={() => setOpenForm(false)}
                      onSaved={handleAfterSave}
                      rentId={idRent}
                  />
                  :
                  <RentDailyFeeForm
                      open={openForm}
                      onClose={() => setOpenForm(false)}
                      onSaved={handleAfterSave}
                      rentId={idRent}
                  />
              }

              <Backdrop
                  sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                  open={activeBackdrop}
              >
                {!isSuccess ? <CircularProgress color="inherit" />
                    : <AnimationGlobal
                        text={'Sua cobrança foi criada com sucesso!'}
                        size={'200px'}
                        animation={successAnimation}
                        fontStyles={{ mb: '1rem' }}
                        fontSize={'20px'}
                        color="#FFFFFF"
                    />
                }
              </Backdrop>
            </Card>
            :
            <Skeleton height={300} width={'100%'} variant='rounded' />
        }
      </Grid>
  );
}

export default RentContractFee
